<div
    *ngIf="tieredCoverage.length"
    class="vp-margin-bottom-12">
    <h5
        [id]="name + '-header-' + tieredCoverage[0].planLevel"
        class="h5 vp-margin-bottom-4">{{name}}</h5>
    <div *ngFor="let coverage of tieredCoverage">
        <div
            class="ip-coverage-amount-item">
            <span
                [id]="'tier-network-individual-' + coverage.coverage + '-coverage'"
                class="ip-coverage-amount-item-text body-regular">{{ coverage.coverage | translate }}</span>
            <span
                [id]="'tier-network-individual-' + coverage.coverage + '-amount'"
                class="ip-coverage-amount-item-text-bold">${{ coverage.amount | number }}</span>
        </div>
    </div>
</div>
